import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-635" data-mp="2optx1v6lzcdq">
      <li className="flex" data-id="element-636" data-mp="2jppi49lcmppm">
        <span className="mr-2" data-id="element-637" data-mp="2jqh1mm1o8wzj">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-638" data-mp="3hcoe0i47vtmg">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-639" data-mp="32n0enmflj51d">
        <span className="mr-2" data-id="element-640" data-mp="32lpb9nq2bzas">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-641" data-mp="3ybcc5349ae3">
          Photographs
        </Link>
      </li>
      <li className="flex" data-id="element-642" data-mp="25a1alht97m2o">
        <span className="mr-2" data-id="element-643" data-mp="1qly509j4icee">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-644" data-mp="1qkwwabpky1zu">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-645" data-mp="1lkin2qc8sm08">
        <span className="mr-2" data-id="element-646" data-mp="17nlykvjljgmi">↑</span>
        <Link to="/prints" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-647" data-mp="17onaf28fs75a">
          Prints
        </Link>
      </li>
      <li className="flex" data-id="element-648" data-mp="35ird6ax7f5p0">
        <span className="mr-2" data-id="element-649" data-mp="35k2dg0rfxvbd">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-650" data-mp="35gy4kq316bed">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;